import type { GetStaffMeResponse } from "@wallyo/contracts/console";
import { createContext, useContext } from "react";

export type StaffContextValue = {
  me: GetStaffMeResponse;
  signOut: () => void;
  signingOut: boolean;
};

export const StaffContext = createContext<StaffContextValue | null>(null);

export function useStaff(): StaffContextValue {
  const value = useContext(StaffContext);
  if (!value) throw new Error("useStaff must be used inside the shell");
  return value;
}

/** "Aminata Diallo" → "AD". */
export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]!.toUpperCase())
    .join("");
}
